import { View } from 'react-native';

import { Badge, Text, createMqStyles, tokens, useMqSelect } from '@fhs/ui';

import { useActiveChallengesBadge } from '../../hooks/use-active-challenges-badge';

export function ChallengesSectionHeader() {
  const mqStyles = useMqStyles();
  const activeChallengesBadge = useActiveChallengesBadge();

  return (
    <View style={mqStyles.container}>
      <Text.Heading type={useMqSelect({ $gteDesktop: 'one' }, 'three')}>Challenges</Text.Heading>
      {!!activeChallengesBadge && (
        <Badge circular style={{ marginLeft: 8 }} color={tokens.colors.$houseRedDarken}>
          {activeChallengesBadge}
        </Badge>
      )}
    </View>
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      flexDirection: 'row',
      marginTop: 16,
      alignItems: 'center',
    },
  },
});
